<template>
<LoginShow ></LoginShow>
  <!-- <Layout id="layout-container"> -->
    <!-- <Header class="header-area">
      <div class="container header-container">
        <div class="logo">
          <img src="../assets/logo_p.gif" height="70" />
        </div>
        <div class="title-area">
          <div id="mainTitle">{{ this.$store.getters.siteInfo.siteName }}</div>
          <div id="subTitle">{{ this.$store.getters.siteInfo.siteEngName }}</div>
        </div>
        <div v-if="this.$store.getters.siteInfo.addon" class="addon-area" v-html="this.$store.getters.siteInfo.addon.header"></div>
      </div>
      <div class="menu-container">
        <div class="container">
          <j2-menu
            ref="menu1"
            :data-list="this.$store.getters.menuInfo"
            :selected-menu-id="this.$store.getters.curMenuId"
            mode="horizontal"
            theme="light"
            @on-select="redirect"
          ></j2-menu>
        </div>
      </div>
    </Header> -->
    <!-- <Layout class="container"> -->
      <!-- 栅格布局 -->
      <!-- <GridContent v-if="$store.getters.curPageDefine.pageInfo.pageType == '0'"></GridContent> -->
     
    <!-- </Layout> -->
     
    <!-- 底部 -->
    <!-- <Footer v-if="this.$store.getters.siteInfo.addon" class="footer-area">
      <div class="container" v-html="this.$store.getters.siteInfo.addon.footer"></div>
    </Footer> -->
  <!-- </Layout> -->
</template>

<script>
import CommonUtil from "../util/CommonUtil";
import APIUtil from "../util/APIUtil";
import GridContent from "../contents/GridContent";
import { dimensionMap } from "view-design/src/utils/assist.js";
import LoginShow from '@/pages/LoginShow'

export default {
  components: {
    GridContent,
    LoginShow
  },

  data() {
    return {
      messageCnt: 0,
      intervalId: null,
      menuStyle: {
        padding: "0px",
        backgroundColor: "#515a6e"
      },
      breakpoint: "sm"
    };
  },

  created() {
    // 初始化数据
    this.fetchData();
  },

  beforeDestroy() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  },

  methods: {
    // 页面初期化
    fetchData() {
      APIUtil.findSiteMenu(this, 1);
    },
    // 菜单点击
    redirect: function(menuInfo) {
      CommonUtil.menuClickHandler(this, menuInfo);
      this.$store.state.drawer_menu_shown = false;
    },
    // 显示菜单栏
    showMenu() {
      let matchMedia = window.matchMedia;
      if (matchMedia(`(max-width: ${dimensionMap[this.breakpoint]})`).matches) {
        this.$store.state.drawer_menu_shown = true;
      } else {
        this.$store.state.sider_menu_collapsed = false;
      }
    }
  }
};
</script>


<style lang="scss" scoped>
.container {
  margin: 0px auto;
  width: 1200px;
}

.header-area {
  // background-color: #f5f7f9;
  padding: 0px;
  height: auto;
  line-height: normal;
}

.header-container {
  height: 100px;
}

.header-container > div {
  float: left;
}

.header-container .logo {
  padding-top: 12px;
}

.header-container .title-area {
  margin-top: 32px;
  margin-left: 15px;
  padding-left: 15px;
  border-left: 2px solid #0a3963;
}

.header-container .title-area #mainTitle {
  font-size: 20px;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-weight: bolder;
}

.header-container .title-area #subTitle {
  font-size: 13px;
}

.header-container .addon-area {
  float: right;
  font-size: 16px;
  margin-top: 60px;
}

.header-container .addon-area a {
  margin: 0px 15px;
}

.menu-container {
  background-color: #0a3963;
}

.menu-container .ivu-menu-light,
.menu-container .ivu-menu-horizontal.ivu-menu-light:after {
  background: transparent;
}

.ivu-menu-horizontal {
  height: 40px;
  line-height: 40px;
}

.ivu-menu /deep/  .ivu-menu-item,
.ivu-menu /deep/  .ivu-menu-submenu {
  /* width: 100px; */
  text-align: center;
}

.menu-container /deep/ .ivu-menu-item-active,
.menu-container /deep/ .ivu-menu-item-selected,
.menu-container /deep/ .ivu-menu-item:hover,
.menu-container /deep/ .ivu-menu-submenu:hover {
  color: #fff;
  border-bottom: 2px solid #fff;
}

.menu-container /deep/ .ivu-menu-light.ivu-menu-horizontal .ivu-menu-item,
.menu-container /deep/ .ivu-menu-light.ivu-menu-horizontal .ivu-menu-submenu {
  color: #fff;
}

.menu-container
  /deep/
  .ivu-menu-light.ivu-menu-horizontal
  .ivu-menu-drop-list
  .ivu-menu-item,
.menu-container
  /deep/
  .ivu-menu-light.ivu-menu-horizontal
  .ivu-menu-drop-list
  .ivu-menu-submenu {
  color: #515a6e;
  border-bottom: none;
  text-align: left;
}

.footer-area {
  background: #0a3963;
  padding: 3px 0px;
  color: #fff;
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/layouts/PortalLayout.vue